export default function tabs() {
    let tabContainer = document.querySelector('.js-tabs-container');

    if (tabContainer) {
        let tab = tabContainer.querySelectorAll('.js-tabs-item');
        let tabContents = document.querySelectorAll('.js-tabs-content');

        [].forEach.call(tab, elem => {
            elem.addEventListener("click", e => {
                e.preventDefault();

                // Set current tab class
                if (tabContainer.querySelector('.tabs__item--active') !== null) {
                    tabContainer.querySelector('.tabs__item--active').classList.remove('tabs__item--active');
                }
                elem.classList.add('tabs__item--active');

                // Show active Tab
                [].forEach.call(tabContents, e => e.classList.remove('tabs__content--active'));
                let activeTab = document.querySelector('#' + elem.getAttribute('data-tab'));

                if (activeTab !== null) {
                    activeTab.classList.add('tabs__content--active');
                }

            });
        });
    }
}

tabs();
